<template>
  <div>
    <div
      v-if="showContainer"
      class="bg-secondary-3 border-radius--light"
      :class="[
        classMain,
        `border-left--color-${borderColor ? borderColor : 'secondary-12'}`,
        {
          'border--left': hasBorder,
        },
      ]"
      :style="cssVars"
    >
      <div class="row row-container">
        <!-- left for md -->
        <div
          class="ml-3 d-flex align-items-center px-1 d-sm-none d-md-flex"
          :class="{ 'gradient-toggle': hasGradient && hasToggle }"
        >
          <em
            v-if="hasToggle"
            class="far font-20"
            :class="{
              'fa-chevron-circle-right color-primary-2': !isOpen,
              'fa-chevron-circle-down color-primary-1': isOpen,
              'fa-chevron-circle-right color-secondary-5': disabled,
            }"
            @click="open"
          />
        </div>
        <div v-if="!hasToggle" style="margin-left: 20px;" />
        <div class="col p-2" :class="{ 'ml-2': hasGradient }">
          <slot />
        </div>
      </div>
      <!-- bottom for sm -->
      <div
        class="row d-flex justify-content-center align-items-center d-md-none d-sm-block bottom-toggle mt-4"
        :class="{ 'gradient-toggle': hasGradient && hasToggle }"
      >
        <em
          v-if="hasToggle"
          class="far font-20"
          :class="{
            'fa-chevron-circle-right color-primary-2': !isOpen,
            'fa-chevron-circle-down color-primary-1': isOpen,
            'fa-chevron-circle-right color-secondary-5': disabled,
          }"
          @click="open"
        />
      </div>
    </div>
    <div
      v-if="isOpen"
      class="bg-secondary-3 border-radius--light p-0"
      :class="classPanel"
    >
      <slot name="edition" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Callout',
  props: {
    hasBorder: {
      type: Boolean,
      default: () => true,
    },
    hasToggle: {
      type: Boolean,
      default: () => true,
    },
    borderColor: {
      type: String,
      default: () => null,
    },
    opened: {
      type: Boolean,
      default: () => false,
    },
    controlled: {
      type: Boolean,
      default: () => false,
    },
    classMain: {
      type: String,
      default: () => '',
    },
    classPanel: {
      type: String,
      default: () => '',
    },
    hasGradient: {
      type: Boolean,
      default: () => true,
    },
    showContainer: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpen: null,
    };
  },
  computed: {
    cssVars() {
      return {
        '--border-color': this.borderColor,
      };
    },
  },
  watch: {
    opened: {
      handler(value) {
        this.isOpen = value;
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      if (!this.disabled) {
        if (!this.controlled) {
          this.isOpen = !this.isOpen;
        } else {
          this.$emit('click:open');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.border--left {
  border-left-style: solid;
  border-left-width: 3px;
}

.gradient-toggle {
  box-shadow: 5px 0px 5px #e2e2e2;
}

@media only screen and (max-width: 768px) {
  $borderColor: var(--border-color);

  .row-container {
    margin: 0px;
  }
  .gradient-toggle {
    box-shadow: 0px 0px 5px #e2e2e2;
  }
  .bottom-toggle {
    margin: 0px;
    text-align: center;
    padding: 5px;
  }
}
</style>
